<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Дополнительные возможности - Презентации
                </h3>
            </div>
            <aside class="col-md-4">
                <MenuComponent/>
            </aside>
            <div class="col-md-8 mb-3">
<!--                <h3 class="text-center mt-5">Раздел в стадии наполнения</h3>-->
                <a href="/files/rollPresentation.pdf" target="_blank" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/pdf.png" alt="pdf">
                            </div>
                            <div class="col-md-11">
                                ПРЕЗЕНТАЦИЯ RM рулонные шторы
                            </div>
                        </div>
                    </div>
                </a>
                <a href="/files/rollZebraPresentation.pdf" target="_blank" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/pdf.png" alt="pdf">
                            </div>
                            <div class="col-md-11">
                                ПРЕЗЕНТАЦИЯ RM рулонные шторы "Зебра"
                            </div>
                        </div>
                    </div>
                </a>
                <a href="/files/rmhorizontpresentation150224.pdf" target="_blank" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/pdf.png" alt="pdf">
                            </div>
                            <div class="col-md-11">
                                ПРЕЗЕНТАЦИЯ RM горизонтальные жалюзи
                            </div>
                        </div>
                    </div>
                </a>
                <a href="/files/catalog2026.pdf" target="_blank" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/pdf.png" alt="pdf">
                            </div>
                            <div class="col-md-11">
                                Технический каталог "КАТРИС", 2026г.
                            </div>
                        </div>
                    </div>
                </a>
                <a href="/files/catalog_cornices2022.pdf" target="_blank" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/pdf.png" alt="pdf">
                            </div>
                            <div class="col-md-11">
                                КАТАЛОГ КАРНИЗОВ "КАТРИС", 2022г.
                            </div>
                        </div>
                    </div>
                </a>
                <a href="/files/romaPresentation23-05-23.pdf" target="_blank" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/pdf.png" alt="pdf">
                            </div>
                            <div class="col-md-11">
                                Презентация римских тканей, 2023г.
                            </div>
                        </div>
                    </div>
                </a>
                <a href="/files/standPresentation.pdf" target="_blank" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/pdf.png" alt="pdf">
                            </div>
                            <div class="col-md-11">
                                Презентация стендов "КАТРИС", 2023г.
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </main>
</template>

<script>
    import MenuComponent from '../components/AdditionalFeaturesMenu';

    export default {
        name: "Presentations",
        metaInfo: {
            title: 'Презентации',
            titleTemplate: '%s - sale.katris'
        },
        components: {
            MenuComponent
        }
    }
</script>

<style scoped>
    .card-body {
        padding: 10px;
    }
    .icon i {
        font-size: 24px
    }
</style>
